import { render } from "./BiliData.vue?vue&type=template&id=1c2a7e4c"
import script from "./BiliData.vue?vue&type=script&lang=js"
export * from "./BiliData.vue?vue&type=script&lang=js"

import exportComponent from "/opt/python_pjs/Django_test/vue_project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__